import React from 'react'
import { OrganizationDeleteWarning } from 'scenes/Dashboard/scenes/OrganizationsManager/components/OrganizationDeleteWarning'

import { Fade, Theme, Typography } from '@mui/material'
import { createStyles, withStyles, WithStyles } from '@mui/styles'

import OrganizationDetailsModal, { OrganizationDetailsModalFooter } from '../../components/OrganizationDetailsModal'
import SectionLoading from '../../components/SectionLoading'
import AddOrganizationButton from './components/AddOrganizationButton'
import AddOrganizationModal from './components/AddOrganizationModal'
import OrganizationDataActions from './components/OrganizationDataActions'
import OrganizationsTable from './components/OrganizationsTable'
import OrganizationTextFilter from './components/OrganizationTextFilter/OrganizationTextFilter.component'

const OrganizationsManager: React.SFC<OrganizationsManagerProps & WithStyles<typeof styles>> = ({
  classes,
  isLoading,
}) => {
  const organizationActionsSection: OrganizationDetailsModalFooter = ({ organization, isInEditMode, isSubmitting }) => {
    if (!organization) {
      return null
    }
    return <OrganizationDataActions organization={organization} isInEditMode={isInEditMode} submitting={isSubmitting} />
  }

  return (
    <Fade in={true}>
      <div>
        <div className={classes.headerContainer}>
          <Typography className={classes.headline}>Organizations Manager</Typography>
          <OrganizationTextFilter />
          <AddOrganizationButton />
        </div>
        <div className={classes.organizationManagerContent}>
          {isLoading && (
            <div className={classes.loadingContainer}>
              <SectionLoading />
            </div>
          )}
          <OrganizationsTable />
          <OrganizationDetailsModal footer={organizationActionsSection} />
          <AddOrganizationModal />
          <OrganizationDeleteWarning />
        </div>
      </div>
    </Fade>
  )
}

export type OrganizationsManagerProps = {
  isLoading: boolean
  search?: string
}

const styles = ({ spacing, typography, breakpoints, palette }: Theme) =>
  // TODO: this is very similar to InvestmentFunnel presentational. DRY.
  createStyles({
    organizationManagerContent: {
      position: 'relative',
    },
    headerContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: spacing(2),
    },
    searchInput: {
      marginRight: spacing(2),
    },
    loadingContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      backgroundColor: palette.background.default,
      zIndex: 2,
    },
    headline: {
      flex: '1 1 auto',
      display: 'inline-block',
      fontSize: typography.h5.fontSize,
      [breakpoints.down('sm')]: {
        fontSize: typography.subtitle1.fontSize,
      },
    },
  })

export default withStyles(styles)(OrganizationsManager)
